import {Link} from 'react-router-dom';
import Head from './head';
import Nav from './nav';
import Footer from './footer';
import Scripts from './scripts';
import './css/home.css';
import './css/btn.css';
import morris from './img/outside/morris.jpg';
import keeney from './img/outside/keeney.jpg';
import hope from './img/outside/hope.jpg';

function Home() {
  return (
    <div className="home">
      <Head/>
      <Nav/>

      <div className="hero">
        <div className="hero-copy">
          <div className="eyebrow">Brown University Housing</div>
          <h1>Find where you'll actually want to live.</h1>
          <p className="hero-sub">Photos, floor plans, and honest reviews from students who've lived there &mdash; all in one place, so you're not piecing it together from group chats.</p>
          <div className="hero-actions">
            <Link className="btn-primary" to="/dorms">
              Browse Dorms
              <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="#fff" strokeWidth="1.8"><path d="M7 4l6 6-6 6" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </Link>
            <Link className="btn-secondary" to="/recommend">Take the quiz</Link>
          </div>
        </div>

        <div className="hero-collage">
          <div className="hero-collage-main" style={{backgroundImage: `url(${morris})`}}>
            <div className="hero-collage-tag">Morris Hall</div>
          </div>
          <div style={{backgroundImage: `url(${keeney})`}}></div>
          <div style={{backgroundImage: `url(${hope})`}}></div>
        </div>
      </div>

      <div className="value-props">
        <div className="value-prop">
          <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="4" width="14" height="12" rx="1"/><circle cx="7.5" cy="8.5" r="1.5"/><path d="M4 14l4-4 3 3 5-5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          <h3>Real photos &amp; floor plans</h3>
          <p>See the room, the bathroom, and the layout before lottery day &mdash; not just a blueprint.</p>
        </div>
        <div className="value-prop">
          <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M10 2l1.9 4.6 5 .4-3.8 3.3 1.2 4.9L10 12.8l-4.3 2.4 1.2-4.9-3.8-3.3 5-.4z" strokeLinejoin="round"/></svg>
          <h3>Reviews from real students</h3>
          <p>Ratings and write-ups from people who actually lived there, good and bad.</p>
        </div>
        <div className="value-prop">
          <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 10a7 7 0 1114 0 7 7 0 01-14 0z"/><path d="M10 6v4l3 2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          <h3>A two-minute quiz</h3>
          <p>Tell us what matters to you and get a short list of dorms worth touring.</p>
        </div>
      </div>

      <Footer/>
      <Scripts/>
    </div>
  );
}

export default Home;
